/** `/c/$companyId/journals/new` — a new manual journal, saved on the first Save or Post. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { JournalEditor } from "../journals/JournalEditor";

export const Route = createFileRoute("/_auth/c/$companyId/journals/new")({
  component: NewJournal,
});

function NewJournal(): JSX.Element {
  const { companyId } = Route.useParams();
  return <JournalEditor companyId={companyId} />;
}
